import SubCont from "@mui/material/Box";
import logo from "../images/logoNew.png";
import Container from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import TextField from "@mui/material/TextField";
import styled from "styled-components";
import CryptoJS from "crypto-js";
import { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  closeLoginModal,
  openSignupModal,
  setPatientDetails,
} from "../reduxtool/action";
import { encryptData, decryptData } from "../Services/TabServices";
import LoginImg from "../images/loginDoctorImage.webp";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

const MainContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 5%;
`;

const Heading = styled.div`
  color: black;
  font-size: 30px;
  font-weight: 600;
  padding: 10px;
`;

const SubHeading = styled.div`
  color: #313131;
  font-size: 16px;
  font-weight: 400;
  padding: 5px 10px;
`;

export default function Login() {
  const dispatch: any = useDispatch();
  const location = useLocation();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const registrationPhoneNo = location.state?.phoneNo || "";
  const [openForm, setopenForm] = useState(true);
  const [showPage, setShowPage] = useState(true);
  const [encryptedOTP, setEncriptedOtp] = useState<any>("");
  const [isOtpSend, setOtpSent] = useState<boolean>(false);
  const [isLoading, setLoading] = useState<boolean>(false);
  const [decryptedOtp, setDecryptedOtp] = useState<any>("");
  const [token, setToken] = useState<string>("");
  const [userId, setUserId] = useState<string>("");
  const [userType, setUserType] = useState<string>("");
  const [formDataOtp, setFormDataOtp] = useState<any | null>({ otp: "" });
  const [otpMethod, setOtpMethod] = useState("sms");
  const [verifyOtpPage, setVerifyOtpPage] = useState<boolean>(false);
  const [formData, setFormData] = useState<any | null>({
    PhoneNo: registrationPhoneNo || "",
  });
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [timer, setTimer] = useState<number>(0);

  // ✅ FIX: Live inline validation state
  const isMobileValid =
    formData.PhoneNo.length === 0 ||
    /^[6-9]\d{0,9}$/.test(formData.PhoneNo);

  const mobileHelperText = !isMobileValid
    ? "Mobile number must start with 6, 7, 8, or 9"
    : formData.PhoneNo.length > 0 && formData.PhoneNo.length < 10
    ? `${10 - formData.PhoneNo.length} more digit(s) required`
    : "";

  // ✅ FIX: handleChange — blocks non-digits, enforces 10 digits,
  //         and restricts first digit to 6–9
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    if (value.length > 10) return;
    if (value.length === 1 && !/^[6-9]$/.test(value)) return; // ✅ KEY FIX
    setFormData({ ...formData, [name]: value });
  };

  const handleChangeOtp = (e: any) => {
    const { name, value } = e.target;
    if (!/^\d*$/.test(value)) return;
    if (value.length > 6) return;
    setFormDataOtp({ ...formDataOtp, [name]: value });
  };

  const handleSendOtp = async (event?: React.FormEvent<HTMLFormElement>) => {
    if (event) event.preventDefault();
    if (!executeRecaptcha) {
      setLoading(false);
      return;
    }

    const recaptchaToken = await executeRecaptcha("callback_request");
    if (!recaptchaToken) {
      setLoading(false);
      return;
    }

    if (!/^[6-9]\d{9}$/.test(formData.PhoneNo)) {
      setError("Please enter a valid 10-digit mobile number starting with 6, 7, 8, or 9.");
      return;
    }

    setError("");
    setVerifyOtpPage(false);
    setLoading(true);
    setOtpSent(false);
    setTimer(20);

    try {
      const response: any = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/Patient/Login`,
        {
          phoneNo: formData.PhoneNo,
          SmsType: otpMethod === "sms" ? "M" : "W",
          recaptchaToken,
        }
      );
      setEncriptedOtp(response.data[0].encryptedOtp);
      setToken(response.data[0].token);
      setUserId(response.data[0].userId);
      setUserType(response.data[0].userType);
      setVerifyOtpPage(true);
      setOtpSent(true);
      setLoading(false);
    } catch (error: any) {
      console.error("Error in sending Otp", error);
      setLoading(false);
      if (error.status == 404) {
        if (error?.response?.data === "This Number Is Not Found Any User") {
          setError("You are not Registered");
        } else {
          setError(error?.response?.data);
        }
      }
    }
  };

  useEffect(() => {
    let interval: any;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setEncriptedOtp("@@");
    }, 5 * 60 * 1000);
    return () => clearTimeout(timeout);
  }, []);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const secretKey = "12345678912345698745632165498712";
    const EncryptionIV = "1234569874123659";
    decryptOtp(encryptedOTP, secretKey, EncryptionIV);
  };

  const decryptOtp = (
    encryptedOtp: string,
    secretKey: string,
    EncryptionIV: string
  ) => {
    try {
      const bytes = CryptoJS.AES.decrypt(
        encryptedOtp,
        CryptoJS.enc.Utf8.parse(secretKey),
        { iv: CryptoJS.enc.Utf8.parse(EncryptionIV) }
      );
      const otp = bytes.toString(CryptoJS.enc.Utf8);
      if (!otp) {
        setError("OTP expired. Please request a new one.");
        return;
      }
      const tempOtp = 123456;
      setDecryptedOtp(tempOtp);
      if (otp === formDataOtp.otp) {
        setError(null);
        if (userType === "P") {
          sessionStorage.setItem("userType", userType);
          sessionStorage.setItem("token", token);
          const encryptedId = encryptData(userId);
          sessionStorage.setItem("userId", encryptedId);
          dispatch(setPatientDetails(token, userId));
          dispatch(closeLoginModal());
        }
      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Decryption failed", error);
    }
  };

  // ✅ Reusable Mobile TextField props (shared for both Mobile & Desktop views)
  const mobileTextFieldProps = {
    required: true,
    label: "Mobile Number",
    name: "PhoneNo",
    value: formData.PhoneNo,
    fullWidth: true,
    size: "small" as const,
    onChange: handleChange,
    error: !isMobileValid,
    helperText: mobileHelperText,
    inputProps: {
      inputMode: "numeric" as const,
      maxLength: 10,
      pattern: "[6-9][0-9]{9}",
    },
  };

  return (
    <Container
      open={true}
      aria-labelledby="modal-modal-title"
      sx={{
        zIndex: 1300,
        opacity: showPage ? 1 : 0,
        transition: "opacity 0.3s ease",
      }}
      onClick={(e: any) => {
        if (e.target === e.currentTarget) {
          dispatch(closeLoginModal());
        }
      }}
    >
      <div>
        {/* ==================== MOBILE VIEW (< 768px) ==================== */}
        <div
          className={`block md:hidden absolute top-1/2 left-1/2 transform 
            -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl 
            w-[85vw] sm:w-[80vw] max-h-[90vh] overflow-y-auto transition-all duration-300
            ${showPage ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
        >
          {/* Mobile Close Button */}
          <CloseIcon
            onClick={() => {
              setShowPage(false);
              setTimeout(() => dispatch(closeLoginModal()), 300);
            }}
            className="float-right relative w-7 h-7 sm:w-8 sm:h-8 right-2 sm:right-1 top-2 sm:top-1 cursor-pointer rounded-full hover:bg-gray-100 transition-all duration-200"
          />

          <div className="px-4 sm:px-5 py-5 sm:py-6">
            {verifyOtpPage ? (
              /* ---------- Mobile OTP Verification ---------- */
              <div className="text-center space-y-4 sm:space-y-5">
                <div className="space-y-2 sm:space-y-3">
                  <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                    <img src={logo} alt="" className="h-auto" />
                  </div>
                  <h1 className="text-lg sm:text-xl font-bold text-gray-900">
                    Verify Now
                  </h1>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed px-2">
                    A verification code has been sent to your mobile number.
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="space-y-3 sm:space-y-4">
                  <div className="space-y-3 sm:space-y-4">
                    <TextField
                      required
                      label="Mobile No"
                      name="PhoneNo"
                      value={formData.PhoneNo}
                      fullWidth
                      disabled
                      size="small"
                      InputProps={{
                        startAdornment: (
                          <span className="mr-2 text-xs sm:text-sm">+91</span>
                        ),
                        style: { backgroundColor: "rgba(249, 250, 251, 0.8)" },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "42px",
                          borderRadius: "12px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                    />

                    <TextField
                      required
                      label="Enter Verification Code"
                      name="otp"
                      value={formDataOtp.otp}
                      fullWidth
                      size="small"
                      onChange={handleChangeOtp}
                      inputProps={{ inputMode: "numeric", maxLength: 6 }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "42px",
                          borderRadius: "12px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "13px" },
                      }}
                    />
                  </div>

                  {/* Mobile Timer/Resend */}
                  <div className="text-center py-2">
                    {timer > 0 ? (
                      <p className="text-gray-600 text-xs sm:text-sm">
                        Resend code in{" "}
                        <span className="font-semibold text-teal-600">
                          {timer}s
                        </span>
                      </p>
                    ) : (
                      <div className="text-xs sm:text-sm">
                        <span className="text-gray-600">
                          Didn't receive the code?{" "}
                        </span>
                        <button
                          type="button"
                          onClick={() => handleSendOtp()}
                          className="font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                        >
                          Resend OTP
                        </button>
                      </div>
                    )}
                  </div>

                  {error && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-2 sm:p-3 rounded-lg">
                      <p className="text-red-700 text-xs sm:text-sm font-medium">
                        {error}
                      </p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`w-full py-2.5 sm:py-3 rounded-lg text-white font-semibold text-sm sm:text-base transition-all duration-200 shadow-lg ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="w-4 h-4 sm:w-5 sm:h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          />
                        </svg>
                        <span className="text-xs sm:text-sm">Verifying...</span>
                      </div>
                    ) : (
                      "Verify & Continue"
                    )}
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setVerifyOtpPage(false);
                      setError("");
                    }}
                    className="w-full py-2 sm:py-2.5 bg-white border-2 border-gray-200 text-gray-700 rounded-lg font-semibold text-sm sm:text-base hover:bg-gray-50 transition-all duration-200"
                  >
                    ← Go Back
                  </button>
                </form>
              </div>
            ) : (
              /* ---------- Mobile Login Form ---------- */
              <div className="text-center space-y-3 sm:space-y-4">
                <div className="space-y-2 sm:space-y-3">
                  <div className="w-full max-w-[150px] flex items-center justify-center mx-auto mb-3">
                    <img src={logo} alt="" className="h-auto" />
                  </div>
                  <p className="text-lg sm:text-xl font-semibold text-gray-900">
                    Welcome to Rama Hospital
                  </p>
                  <p className="text-gray-600 text-xs sm:text-sm leading-relaxed px-2">
                    Login to access your account and manage appointments
                  </p>
                </div>

                <form onSubmit={handleSendOtp} className="space-y-3 sm:space-y-4">
                  <div className="space-y-3 text-left">
                    {/* ✅ FIXED Mobile Number TextField */}
                    <TextField
                      {...mobileTextFieldProps}
                      InputProps={{
                        startAdornment: (
                          <span className="mr-2 text-xs sm:text-sm">+91</span>
                        ),
                        style: { backgroundColor: "transparent" },
                      }}
                      sx={{
                        "& .MuiInputBase-root": {
                          height: "42px",
                          borderRadius: "12px",
                          fontSize: "13px",
                        },
                        "& .MuiInputLabel-root": { fontSize: "12px" },
                      }}
                    />

                    <div className="bg-blue-50 border border-blue-200 rounded-lg p-2 sm:p-3">
                      <div className="flex items-start gap-2">
                        <svg
                          className="w-4 h-4 sm:w-5 sm:h-5 text-blue-500 mt-0.5 flex-shrink-0"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                          />
                        </svg>
                        <p className="text-blue-700 text-xs leading-relaxed">
                          We'll send you a verification code via SMS to complete
                          your login securely.
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* OTP Method Selection */}
                  <div className="space-y-2 py-2 bg-blue-50 border border-blue-200 rounded-lg p-2 text-left">
                    <p className="font-semibold text-xs">Send OTP via</p>
                    <div className="flex items-center gap-6 lg:gap-8">
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="otpMethod"
                          value="sms"
                          className="h-3 w-3"
                          checked={otpMethod === "sms"}
                          onChange={(e) => setOtpMethod(e.target.value)}
                        />
                        <span className="text-xs">SMS</span>
                      </label>
                      <label className="flex items-center gap-2 cursor-pointer">
                        <input
                          type="radio"
                          name="otpMethod"
                          value="whatsapp"
                          className="h-3 w-3"
                          checked={otpMethod === "whatsapp"}
                          onChange={(e) => setOtpMethod(e.target.value)}
                        />
                        <span className="text-xs">WhatsApp</span>
                      </label>
                    </div>
                  </div>

                  {error && (
                    <div className="bg-red-50 border-l-4 border-red-400 p-2 sm:p-3 rounded-lg text-left">
                      <p className="text-red-700 text-xs sm:text-sm font-medium">
                        {error}
                      </p>
                    </div>
                  )}

                  <button
                    type="submit"
                    disabled={isLoading}
                    className={`w-full py-2.5 sm:py-3 rounded-lg text-white font-semibold text-sm sm:text-base transition-all duration-200 shadow-lg ${
                      isLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700 active:scale-95"
                    }`}
                  >
                    {isLoading ? (
                      <div className="flex items-center justify-center space-x-2">
                        <svg
                          className="w-4 h-4 sm:w-5 sm:h-5 animate-spin"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          />
                        </svg>
                        <span className="text-xs sm:text-sm">
                          Sending Code...
                        </span>
                      </div>
                    ) : (
                      "Continue with Mobile"
                    )}
                  </button>

                  <p className="text-xs text-gray-600 leading-relaxed px-2">
                    By continuing, you agree to Rama Hospital's{" "}
                    <Link
                      to="/privacy"
                      className="text-teal-600 font-medium hover:underline"
                    >
                      Privacy Policy
                    </Link>{" "}
                    and{" "}
                    <Link
                      to="/terms_conditions"
                      className="text-teal-600 font-medium hover:underline"
                    >
                      Terms of Service
                    </Link>
                  </p>

                  <div className="pt-2 border-t border-gray-100">
                    <div className="flex items-center gap-1 text-xs sm:text-sm">
                      <span className="text-gray-600">
                        Don't have an account?
                      </span>
                      <span
                        onClick={() => {
                          setShowPage(false);
                          setTimeout(() => {
                            dispatch(closeLoginModal());
                            dispatch(openSignupModal());
                          }, 300);
                        }}
                        className="font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer underline"
                      >
                        Create Account
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>

        {/* ==================== TABLET & DESKTOP VIEW (≥ 768px) ==================== */}
        <div
          className={`hidden md:block absolute top-1/2 left-1/2 transform 
            -translate-x-1/2 -translate-y-1/2 bg-white shadow-2xl outline-none rounded-2xl 
            w-[75vw] lg:w-[60vw] xl:w-[50vw] 2xl:w-[50vw] max-h-[95vh] overflow-y-auto 
            transition-all duration-300
            ${showPage ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}
        >
          {/* Desktop Close Button */}
          <CloseIcon
            onClick={() => {
              setShowPage(false);
              setTimeout(() => dispatch(closeLoginModal()), 300);
            }}
            className="float-right relative top-2 right-2 cursor-pointer rounded-full hover:bg-gray-100 transition-all duration-200"
          />

          <div className="flex flex-col lg:flex-row justify-between items-stretch gap-0">
            {/* Image Section */}
            <div className="hidden lg:flex items-center justify-center lg:w-1/2 bg-gradient-to-br from-blue-50 to-teal-50 rounded-l-2xl overflow-hidden">
              <img
                src={LoginImg}
                alt="Login"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="w-full lg:w-1/2 px-5 lg:px-7 py-5 lg:py-7">
              {verifyOtpPage ? (
                /* ---------- Desktop OTP Verification ---------- */
                <div className="text-center space-y-4 lg:space-y-5">
                  <div className="space-y-1 lg:space-y-2">
                    <h1 className="text-xl lg:text-2xl font-bold text-gray-900">
                      Verify Now
                    </h1>
                    <p className="text-gray-600 text-sm">
                      A verification code has been sent to your mobile number.
                    </p>
                  </div>

                  <form
                    onSubmit={handleSubmit}
                    className="space-y-3 lg:space-y-4"
                  >
                    <div className="space-y-3 lg:space-y-4">
                      <TextField
                        required
                        label="Mobile No"
                        name="PhoneNo"
                        value={formData.PhoneNo}
                        fullWidth
                        disabled
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <span className="mr-2">+91</span>
                          ),
                          style: {
                            backgroundColor: "rgba(249, 250, 251, 0.8)",
                          },
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "14px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "14px" },
                        }}
                      />

                      <TextField
                        required
                        label="Enter Verification Code"
                        name="otp"
                        value={formDataOtp.otp}
                        fullWidth
                        size="small"
                        onChange={handleChangeOtp}
                        inputProps={{ inputMode: "numeric", maxLength: 6 }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "14px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "14px" },
                        }}
                      />
                    </div>

                    {/* Desktop Timer/Resend */}
                    <div className="text-center py-2">
                      {timer > 0 ? (
                        <p className="text-gray-600 text-sm lg:text-base">
                          Resend code in{" "}
                          <span className="font-semibold text-teal-600">
                            {timer}s
                          </span>
                        </p>
                      ) : (
                        <div className="text-sm lg:text-base">
                          <span className="text-gray-600">
                            Didn't receive the code?{" "}
                          </span>
                          <button
                            type="button"
                            onClick={() => handleSendOtp()}
                            className="font-semibold text-teal-600 hover:text-teal-700 transition-colors underline"
                          >
                            Resend OTP
                          </button>
                        </div>
                      )}
                    </div>

                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-2 lg:p-3 rounded-lg">
                        <p className="text-red-700 text-xs lg:text-sm font-medium">
                          {error}
                        </p>
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={isLoading}
                      className={`w-full py-2.5 lg:py-3 rounded-lg text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                        isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isLoading ? "Verifying..." : "Verify & Continue"}
                    </button>

                    <button
                      type="button"
                      onClick={() => {
                        setVerifyOtpPage(false);
                        setError("");
                      }}
                      className="w-full py-2.5 lg:py-3 bg-white border-2 border-gray-200 text-gray-700 rounded-lg font-semibold text-base hover:bg-gray-50"
                    >
                      ← Go Back
                    </button>
                  </form>
                </div>
              ) : (
                /* ---------- Desktop Login Form ---------- */
                <div className="text-center space-y-4 lg:space-y-5">
                  <div className="space-y-1 lg:space-y-2">
                    <p className="text-xl lg:text-2xl font-semibold text-gray-900">
                      Welcome to Rama Hospital
                    </p>
                    <p className="text-gray-600 text-sm">
                      Login to access your account and manage appointments
                    </p>
                  </div>

                  <form
                    onSubmit={handleSendOtp}
                    className="space-y-3 lg:space-y-4"
                  >
                    <div className="space-y-3 lg:space-y-4 text-left">
                      {/* ✅ FIXED Desktop Number TextField */}
                      <TextField
                        {...mobileTextFieldProps}
                        InputProps={{
                          startAdornment: (
                            <span className="mr-2">+91</span>
                          ),
                          style: { backgroundColor: "transparent" },
                        }}
                        sx={{
                          "& .MuiInputBase-root": {
                            height: "40px",
                            borderRadius: "10px",
                            fontSize: "14px",
                          },
                          "& .MuiInputLabel-root": { fontSize: "14px" },
                        }}
                      />

                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-1">
                        <div className="flex items-start gap-2">
                          <svg
                            className="w-4 h-4 text-blue-500 mt-0.5 flex-shrink-0"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="2"
                              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                            />
                          </svg>
                          <p className="text-blue-700 text-xs leading-relaxed">
                            We'll send you a verification code via SMS to
                            complete your login securely.
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* OTP Method Selection */}
                    <div className="space-y-2 py-3 bg-blue-50 border border-blue-200 rounded-lg p-3 text-left">
                      <p className="font-semibold text-xs text-gray-700">
                        Send OTP via
                      </p>
                      <div className="flex items-center gap-4 lg:gap-6">
                        {/* SMS Option */}
                        <label
                          className="flex items-center gap-2 cursor-pointer group"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOtpMethod("sms");
                          }}
                        >
                          <div className="relative flex items-center justify-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 transition-all duration-200 ${
                                otpMethod === "sms"
                                  ? "border-teal-600 bg-teal-50"
                                  : "border-gray-300 bg-white group-hover:border-teal-400"
                              }`}
                            >
                              {otpMethod === "sms" && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                                </div>
                              )}
                            </div>
                          </div>
                          <span className="text-xs">SMS</span>
                        </label>

                        {/* WhatsApp Option */}
                        <label
                          className="flex items-center gap-2 cursor-pointer group"
                          onClick={(e) => {
                            e.stopPropagation();
                            setOtpMethod("whatsapp");
                          }}
                        >
                          <div className="relative flex items-center justify-center">
                            <div
                              className={`w-4 h-4 rounded-full border-2 transition-all duration-200 ${
                                otpMethod === "whatsapp"
                                  ? "border-teal-600 bg-teal-50"
                                  : "border-gray-300 bg-white group-hover:border-teal-400"
                              }`}
                            >
                              {otpMethod === "whatsapp" && (
                                <div className="absolute inset-0 flex items-center justify-center">
                                  <div className="w-2 h-2 rounded-full bg-teal-600"></div>
                                </div>
                              )}
                            </div>
                          </div>
                          <span className="text-xs">WhatsApp</span>
                        </label>
                      </div>
                    </div>

                    {error && (
                      <div className="bg-red-50 border-l-4 border-red-400 p-2 lg:p-3 rounded-lg text-left">
                        <p className="text-red-700 text-xs lg:text-sm font-medium">
                          {error}
                        </p>
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={isLoading}
                      className={`w-full py-2.5 lg:py-3 rounded-lg text-white font-semibold text-base transition-all duration-200 shadow-lg ${
                        isLoading
                          ? "bg-gray-400 cursor-not-allowed"
                          : "bg-gradient-to-r from-teal-500 to-teal-600 hover:from-teal-600 hover:to-teal-700"
                      }`}
                    >
                      {isLoading ? "Sending Code..." : "Continue with Mobile"}
                    </button>

                    <p className="text-xs text-gray-600 leading-relaxed px-2">
                      By continuing, you agree to Rama Hospital's{" "}
                      <Link
                        to="/privacy"
                        className="text-teal-600 font-medium hover:underline"
                      >
                        Privacy Policy
                      </Link>{" "}
                      and{" "}
                      <Link
                        to="/terms_conditions"
                        className="text-teal-600 font-medium hover:underline"
                      >
                        Terms of Service
                      </Link>
                    </p>

                    <div className="pt-1 border-t border-gray-100">
                      <div className="flex items-center justify-center gap-1 text-sm">
                        <span className="text-gray-600">
                          Don't have an account?
                        </span>
                        <span
                          onClick={() => {
                            setShowPage(false);
                            setTimeout(() => {
                              dispatch(closeLoginModal());
                              dispatch(openSignupModal());
                            }, 300);
                          }}
                          className="font-semibold text-teal-600 hover:text-teal-700 transition-colors cursor-pointer underline"
                        >
                          Create Account
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
